<!-- Chat panel -->
@if (open()) {
  <div class="igc-panel" [class.igc-panel--expanded]="expanded()" role="dialog" aria-label="Ignite Assistant">
    <!-- Header -->
    <div class="igc-header">
      @if (historyView() || helpView()) {
        <button type="button" class="igc-hbtn" (click)="backToChat()" aria-label="Back to chat">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M15 5l-7 7 7 7" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
        </button>
        <div class="igc-title igc-title--grow">{{ historyView() ? 'Chat History' : 'Help' }}</div>
      }
      @if (chatView()) {
        <img src="/assets/images/logo-burst.png" alt="" class="igc-avatar igc-avatar--header" />
        <div class="igc-title-block">
          <div class="igc-title">Ignite Assistant <span class="igc-badge">Beta</span></div>
          <div class="igc-status"><span class="igc-status-dot"></span>Online now</div>
        </div>
        <button #moreButton type="button" class="igc-hbtn" (click)="toggleMenu()" aria-haspopup="true" [attr.aria-expanded]="menuOpen()" aria-label="More">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="5" r="1.6" fill="#fff" />
            <circle cx="12" cy="12" r="1.6" fill="#fff" />
            <circle cx="12" cy="19" r="1.6" fill="#fff" />
          </svg>
        </button>
      }
      <button type="button" class="igc-hbtn" (click)="toggleExpand()" [attr.aria-expanded]="expanded()" [attr.aria-label]="expanded() ? 'Collapse chat' : 'Expand chat'" [attr.title]="expanded() ? 'Collapse chat' : 'Expand chat'">
        @if (expanded()) {
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M3 9h6V3M21 15h-6v6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
        } @else {
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 3H3v6M15 21h6v-6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
        }
      </button>
      <button type="button" class="igc-hbtn" (click)="closeChat()" aria-label="Close assistant">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="#fff" stroke-width="2" stroke-linecap="round" /></svg>
      </button>
    </div>

    @if (menuOpen()) {
      <div class="igc-menu-backdrop" (click)="closeMenu()" aria-hidden="true"></div>
      <div class="igc-menu" role="menu" aria-label="Assistant menu">
        <button #firstMenuItem type="button" class="igc-mi" role="menuitem" aria-label="New chat" (click)="newChat()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M12 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6" stroke="#132d77" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17 3.5l3.5 3.5L13 14.5l-4 1 1-4z" stroke="#132d77" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          New chat
        </button>
        <button type="button" class="igc-mi" role="menuitem" aria-label="Chat history" (click)="showHistory()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M12 7v5l3.5 2" stroke="#132d77" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3.5 12a8.5 8.5 0 1 0 2.6-6.1M3.5 4.5V9H8" stroke="#132d77" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Chat history
        </button>
        <button type="button" class="igc-mi igc-mi--divider" role="menuitem" aria-label="Help" (click)="showHelp()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="9" stroke="#132d77" stroke-width="2" />
            <path d="M9.5 9.5a2.5 2.5 0 0 1 4.6-1.35c.5.8.35 1.85-.4 2.45l-.6.48A2 2 0 0 0 12.4 12.5v.3" stroke="#132d77" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <circle cx="12.4" cy="16" r="1" fill="#132d77" />
          </svg>
          Help
        </button>
      </div>
    }

    <!-- Chat view -->
    @if (chatView()) {
      <div #scrollContainer class="igc-body">
        @for (message of messages(); track $index) {
          @if (message.role === 'bot') {
            <div class="igc-msg igc-msg--bot">
              <img src="/assets/images/logo-burst.png" alt="" class="igc-avatar" />
              <div class="igc-bubble igc-bubble--bot igc-md">
                <div [innerHTML]="message.text | markdown"></div>
                @if (message.turnId !== undefined) {
                  <div class="igc-feedback">
                    <button type="button" class="igc-feedback-btn" [class.igc-feedback-btn--active]="message.rating === 'up'" (click)="rateMessage(message, 'up')" aria-label="Thumbs up">👍</button>
                    <button type="button" class="igc-feedback-btn" [class.igc-feedback-btn--active]="message.rating === 'down'" (click)="rateMessage(message, 'down')" aria-label="Thumbs down">👎</button>
                    @if (feedbackErrorTurnId() === message.turnId) {
                      <span class="igc-feedback-error" title="Couldn't submit feedback. Please try again.">Feedback failed</span>
                    }
                  </div>
                }
              </div>
            </div>
          } @else {
            <div class="igc-msg igc-msg--user">
              <div class="igc-bubble igc-bubble--user">{{ message.text }}</div>
            </div>
          }
        }
        @if (typing()) {
          <div class="igc-msg igc-msg--bot">
            <img src="/assets/images/logo-burst.png" alt="" class="igc-avatar" />
            <div class="igc-bubble igc-bubble--bot igc-typing" aria-label="Assistant is typing" aria-live="polite"> <span class="igc-dot"></span><span class="igc-dot"></span><span class="igc-dot"></span> </div>
          </div>
        }
        @if (showSuggestions()) {
          <div class="igc-suggestions">
            <span class="igc-suggestions-label">Suggested questions</span>
            @for (question of presetQuestions; track question) {
              <button type="button" class="igc-chip" [attr.aria-label]="'Ask: ' + question" (click)="populateInput(question)">{{ question }}</button>
            }
          </div>
        }
      </div>
      @if (showCharCount()) {
        <div class="igc-charcount" [class.igc-charcount--limit]="input().length >= maxInputLength">{{ input().length }}/{{ maxInputLength }}</div>
      }
      <div class="igc-inputbar">
        <textarea
          #chatInput
          class="igc-input"
          rows="1"
          [value]="input()"
          (input)="onInput($event)"
          (keydown)="onKey($event)"
          [attr.maxlength]="maxInputLength"
          [placeholder]="inputPlaceholder()"
          [disabled]="typing()"
          [attr.aria-busy]="typing()"
          aria-label="Ask a question"></textarea>
        <button type="button" class="igc-send" [disabled]="typing()" (click)="send()" aria-label="Send">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 12l16-8-6 16-3-6z" fill="#fff" /></svg>
        </button>
      </div>
    }

    <!-- History view -->
    @if (historyView()) {
      <div class="igc-history">
        <button type="button" class="igc-chip igc-chip--new" aria-label="Start a new chat" (click)="newChat()">+ New chat</button>
        @if (openConversationError()) {
          <div class="igc-empty">This conversation is no longer available.</div>
        }
        @if (deleteConversationError()) {
          <div class="igc-empty">Couldn't delete that conversation. Please try again.</div>
        }
        @if (historyRefreshing()) {
          <!-- Sized like real rows so the swap-in below doesn't shift layout; hides any stale list during a refresh instead of flashing it. -->
          @for (row of skeletonRows; track row) {
            <div class="igc-row igc-row--skeleton" aria-hidden="true">
              <div class="igc-skeleton-bar igc-skeleton-bar--title"></div>
              <div class="igc-skeleton-bar igc-skeleton-bar--snippet"></div>
              <div class="igc-skeleton-bar igc-skeleton-bar--time"></div>
            </div>
          }
        } @else {
          @if (historyError()) {
            <div class="igc-empty">Couldn't load your chat history. Please try again.</div>
          }
          @if (!historyError() && noConversations()) {
            <div class="igc-empty">No saved conversations yet.<br />Ask a question to start one.</div>
          }
          @for (conversation of conversations(); track conversation.conversationId) {
            <div class="igc-row igc-row--enter" (click)="openConversation(conversation.conversationId)">
              <div class="igc-row-title">{{ conversationTitle(conversation) }}</div>
              <div class="igc-row-snippet">{{ conversation.lastResponseMessage }}</div>
              <div class="igc-row-time">{{ formatTime(conversation.updatedAt) }}</div>
              <button type="button" class="igc-del" (click)="removeConversation(conversation.conversationId, $event)" aria-label="Delete conversation">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M5 7h14M10 7V5h4v2M6 7l1 13h10l1-13" stroke="#c41b07" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
              </button>
            </div>
          }
          @if (historyHasNext()) {
            <button type="button" class="igc-chip igc-chip--load-more" [disabled]="historyLoading()" (click)="loadMoreHistory()">{{ historyLoading() ? 'Loading…' : 'Load more' }}</button>
          }
        }
      </div>
    }

    <!-- Help view -->
    @if (helpView()) {
      <div class="igc-help">
        <input class="igc-help-search" type="text" [value]="searchQuery()" (input)="onSearchInput($event)" placeholder="Search questions…" aria-label="Search help questions" />
        @if (filteredCategories().length === 0) {
          <div class="igc-empty">No matching questions.</div>
        }
        @for (group of filteredCategories(); track group.category) {
          <div class="igc-help-category">
            <button type="button" class="igc-help-category-head" [class.igc-help-category-head--open]="isCategoryOpen(group.category)" [attr.aria-expanded]="isCategoryOpen(group.category)" (click)="toggleCategory(group.category)">
              <span class="igc-help-category-text">
                <span class="igc-help-category-title">{{ group.category }}</span>
                <span class="igc-help-category-desc">{{ group.description }}</span>
              </span>
              <span class="igc-help-chevron">{{ isCategoryOpen(group.category) ? '▾' : '▸' }}</span>
            </button>
            <div [ngbCollapse]="!isCategoryOpen(group.category)">
              @for (question of group.questions; track question) {
                <button type="button" class="igc-help-question" [disabled]="typing()" [attr.aria-label]="'Help question: ' + question" (click)="askFromHelp(question)">{{ question }}</button>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}

<!-- Launcher -->
<button type="button" class="igc-fab" (click)="toggleOpen()" [attr.aria-expanded]="open()" [attr.aria-label]="open() ? 'Close Ignite Assistant' : 'Open Ignite Assistant'">
  @if (open()) {
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="#fff" stroke-width="2.2" stroke-linecap="round" /></svg>
  } @else {
    <svg width="27" height="27" viewBox="0 0 24 24" fill="none">
      <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5v9a1.5 1.5 0 0 1-1.5 1.5H9l-4 3.5v-3.5H5.5A1.5 1.5 0 0 1 4 14.5z" fill="#fff" />
      <circle cx="9" cy="10" r="1.2" fill="#132d77" />
      <circle cx="12" cy="10" r="1.2" fill="#132d77" />
      <circle cx="15" cy="10" r="1.2" fill="#132d77" />
    </svg>
  }
</button>
